import React from "react";

const CommingSoon = () => {
  return (
    <div>
      <div className="not_found">
        <div className="container">
          <img
            src="/assets/img/comming_soon.png"
            className="img-fluid"
            alt="comming_soon"
          />
          <h1 className="mt-4">Coming Soon...</h1>
          <a className="btn btn_man mt-4  w100px mt-4" href="/">
            Go Home
          </a>
        </div>
      </div>
    </div>
  );
};

export default CommingSoon;
